// @flow
// @flow-runtime warn
import { createContext } from 'react';

import type { AccountBalanceType, AccountBalanceHistoryType } from './AccountBalanceTypes';


type ContentType = {
  ...$Exact<AccountBalanceType>,
  history: AccountBalanceHistoryType,
}

export const defaultBalanceState = {
  cafeteria_balance: null,
  primary_balance: null,
};

export const defaultBalanceHistoryState = {};

const defaultContent: ContentType = {
  ...defaultBalanceState,
  history: defaultBalanceHistoryState,
};

type LoadingType = {
  balance: boolean,
  history: boolean,
}

const defaultLoading: LoadingType = {
  balance: false,
  history: false,
};

type RequestsType = {
  balance: () => Promise<void> | void,
  history: (from: string, to: string) => Promise<void> | void,
}

const defaultRequests = {
  balance: () => {},
  history: () => {},
};

type AccountBalanceContextType = {
  content: ContentType,
  loading: LoadingType,
  request: RequestsType,
}

const defaultContext: AccountBalanceContextType = {
  content: defaultContent,
  loading: defaultLoading,
  request: defaultRequests,
};

export default createContext<AccountBalanceContextType>(defaultContext);
